import React from "react";
import { Trash2 } from "lucide-react";
import { QuantityStepper } from "@/components/product/QuantityStepper";
import { formatINR } from "@/lib/format";

function variantLabel(product, variantId) {
  const v = product.variants?.find((x) => x.id === variantId);
  return !v || v.title === "Default" ? null : v.title;
}

export function CartLineItem({ item, lineId, onQuantity, onRemove }) {
  const vLabel = variantLabel(item.product, item.variantId);
  return (
    <li className="flex gap-4 py-5" data-testid="cart-line-item">
      <div className="h-24 w-20 shrink-0 overflow-hidden bg-cream">
        <img src={item.product.images?.[0]} alt={item.product.title} className="h-full w-full object-cover" />
      </div>
      <div className="flex flex-1 flex-col">
        <div className="flex items-start justify-between gap-2">
          <div>
            <h3 className="font-serif text-base leading-tight text-ink">{item.product.title}</h3>
            {vLabel && <p className="mt-0.5 text-xs text-muted-foreground">{item.product.options?.name}: {vLabel}</p>}
          </div>
          <button onClick={() => onRemove(lineId)} aria-label="Remove item" data-testid="cart-line-remove" className="text-muted-foreground transition-colors hover:text-destructive">
            <Trash2 size={16} />
          </button>
        </div>
        <div className="mt-auto flex items-center justify-between pt-3">
          <QuantityStepper value={item.quantity} min={0} size="sm" onChange={(q) => onQuantity(lineId, q)} />
          <span className="text-sm font-semibold text-ink">{formatINR(item.product.price * item.quantity)}</span>
        </div>
      </div>
    </li>
  );
}
